
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.6","d":"M2.5 8.13h15.28a3.05 3.05 0 013.05 3.05v10.7h0H5.55a3.05 3.05 0 01-3.05-3.06V8.13h0z"}}),_c('path',{attrs:{"stroke-width":"1.2","d":"M20.83 12.17l6.67-4.04v13.75l-6.67-4.05"}})])])
          )
        }
      }
    